import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class AreaService {
  
get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }  constructor(private http: HttpClient) { }

  getArea(data: any): Observable<any> {
    //return this.http.post<any>(this.baseUrl + 'masterarea', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'AreaIntegrated/GetMasterAuditDetails', data);
  }
  addArea(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'area', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'AreaIntegrated/AddAuditArea', data);
  }
  updateArea(data: any): Observable<any[]> {
    // return this.http.put<any[]>(this.baseUrl + 'area', data);
    return this.http.put<any[]>(this.O3CoreApiUrl + 'AreaIntegrated/UpdateAuditArea', data);
  }
  deleteArea(data: any): Observable<any> {
    // return this.http.post<any>(this.baseUrl + 'deletearea', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'AreaIntegrated/DeleteAuditDetail', data);
  }
  getQualityArea(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'QualityArea/GetQualityAreaByPlantId', data);
    // return this.http.post<any>(this.baseUrl + 'masterqualityarea', data);
  }

  //NOT IN USE
  // getQualityMasterArea(): Observable<any> {
  //   return this.http.get<any>(this.baseUrl + 'qualityareas');
  // }

  //NOT IN USE
  // deleteQulaityMasterArea(data: any): Observable<any> {
  //   return this.http.post<any>(this.baseUrl + 'deletequalityarea', data);
  // }

  //NOT IN USE
  // updateQualityMasterArea(data: any): Observable<any[]> {
  //   return this.http.put<any[]>(this.baseUrl + 'updatequalityarea', data);
  // }

  //NOT IN USE
  // getQualityMasterAreaById(data: any): any {
  //   return this.http.post<any>(this.baseUrl + 'qualityarea', data);
  // }

  getMasterArea(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Area/masterareabygroup', data);
  }
  getAuditCheckpoint(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'AMAuditCheckPoint/GetAuditAreaByPlant', data);
  }
  getProcessCheckpoint(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'AmProcessCheckPoint/GetProcessAreaByPlant', data);
  }

  getMasterAreaByDepartment(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Master/GetMasterAreaByDepartmentId', data);
    // return this.http.post<any>(this.baseUrl + 'masterareabydepartment', data);
  }
  getSectioMmanagerbyArea(data: any): Observable<any> {
    // return this.http.post<any>(this.baseUrl + 'getsectionmanagerbyarea', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'AreaIntegrated/GetSectionManagerByArea', data);
  }

  getMasterShiftDataFor5sShift(): Observable<any> {
    return this.http.get<any>(this.O3CoreApiUrl + 'CrewSchedule/getMasterShiftDataFor5sShift');
  }
  saveFiveSShift(data: any): Observable<any> {
  return this.http.post(this.O3CoreApiUrl +'AreaIntegrated/SaveFiveSShift', data);
}
getShiftsByPlantCode(): Observable<any[]> {
    return this.http.get<any[]>(this.O3CoreApiUrl +'AreaIntegrated/GetFiveSShiftsByPlantCode');
  }

  updateFiveSShift(payload: any) {
  return this.http.post(this.O3CoreApiUrl +'AreaIntegrated/UpdateFiveSShift', payload); // Adjust URL and payload as needed
}

deleteFiveSShift(payload: any) {
  return this.http.post(this.O3CoreApiUrl +'AreaIntegrated/DeleteFiveSShift', payload); // Adjust URL and payload as needed
}
}


// import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';
// 

// @Injectable({
//   providedIn: 'root'
// })
// export class AreaService {

//   constructor(private http: HttpClient) { }

//   getArea(data: any): Observable<any> {
//      const token = localStorage.getItem('token');
//      const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
//     return this.http.post<any>(this.baseUrl + 'qualityareas', data);
//   }

//   getMasterArea(): Observable<any> {
//     const token = localStorage.getItem('token');
//     const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
//    return this.http.get<any>(this.baseUrl + 'qualityareas',  {headers: header});
//  }
//   getQualityArea(data: any): Observable<any> {
//    return this.http.post<any>(this.baseUrl + 'masterqualityarea', data);
//  }
//  getMasterAreaById(data:any): any {
//   const token = localStorage.getItem('token');;//localStorage.getItem('token');
//   const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
//   return this.http.post<any>(this.baseUrl + 'qualityarea',data,{headers: header});
// }
// // updateMasterArea(data: any): Observable <any[]> {
// //   const token = localStorage.getItem('token');
// //   const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
// //   return this.http.put<any[]>(this.baseUrl + 'updatequalityarea', data );
// // }
//   addArea(data: any): Observable<any[]> {
//     const token = localStorage.getItem('token');
//     const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
//     return this.http.post<any[]>(this.baseUrl + 'addqualityarea', data );
//   }
//   updateArea(data: any): Observable <any[]> {
//     const token = localStorage.getItem('token');
//     const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
//     return this.http.put<any[]>(this.baseUrl + 'area', data );
//   }
//   updateMasterArea(data: any): Observable <any[]> {
//     const token = localStorage.getItem('token');
//     const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
//     return this.http.put<any[]>(this.baseUrl + 'updatequalityarea', data );
//   }
//   deleteArea(data: any): Observable<any> {
//     const token = localStorage.getItem('token');
//     const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
//     return this.http.post<any>(this.baseUrl + 'deletearea', data );
//   }
//   deleteMasterArea(data: any): Observable<any> {
//     const token = localStorage.getItem('token');
//     const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
//     return this.http.post<any>(this.baseUrl + 'deletequalityarea', data );
//   }
// }
